import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  CircularProgress,
} from '@material-ui/core';
import { useForm, FormProvider } from 'react-hook-form';
import FormInput from '../ReactHookForm/FormInput/FormInput';

const FORM_FIELDS = {
  NAME: 'name',
  PRODUCT_CODE: 'productCode',
  DESCRIPTION: 'description',
  IS_RESIDENTIAL: 'isResidential',
};

export const CreateProductModal = ({ open, onClose, onSave }) => {
  const methods = useForm({
    defaultValues: {
      [FORM_FIELDS.NAME]: '',
      [FORM_FIELDS.PRODUCT_CODE]: '',
      [FORM_FIELDS.DESCRIPTION]: '',
      [FORM_FIELDS.IS_RESIDENTIAL]: true, // Default to residential
    },
  });

  const { handleSubmit, formState: { isSubmitting }, watch } = methods;

  const onSubmit = async (data) => {
    try {
      await onSave(data);
      onClose();
    } catch (error) {
      console.error('Error creating product:', error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Create New Product
        <div style={{ fontSize: 14, color: '#888', fontWeight: 400, marginTop: 4 }}>
          This form will submit a requst for product crateion to the MorelandConnect Team. You will be notified when the request has been completed.
        </div>
      </DialogTitle>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <FormInput
                  type="text"
                  name={FORM_FIELDS.NAME}
                  label="Product Name"
                  rules={{ required: 'Product name is required' }}
                />
              </Grid>
              <Grid item xs={6}>
                <FormInput
                  type="text"
                  name={FORM_FIELDS.PRODUCT_CODE}
                  label="Product Code"
                  rules={{ required: 'Product code is required' }}
                />
              </Grid>
              <Grid item xs={12}>
                <FormInput
                  type="text"
                  name={FORM_FIELDS.DESCRIPTION}
                  label="Description"
                  multiline
                  rows={3}
                />
              </Grid>
              <Grid item xs={12}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '16px' }}>
                  <div style={{ width: '80px', textAlign: 'right' }}>
                    <span style={{ color: '#666' }}>Commercial</span>
                  </div>
                  <div style={{ margin: '0 8px' }}>
                    <FormInput
                      type="switch"
                      name={FORM_FIELDS.IS_RESIDENTIAL}
                      hideLabel
                    />
                  </div>
                  <div style={{ width: '80px', textAlign: 'left' }}>
                    <span style={{ color: watch(FORM_FIELDS.IS_RESIDENTIAL) ? '#2196f3' : '#666' }}>Residential</span>
                  </div>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} color="primary">
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={isSubmitting}
              startIcon={isSubmitting && <CircularProgress size={20} color="inherit" />}
            >
              {isSubmitting ? 'Creating...' : 'Create Product'}
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </Dialog>
  );
};
